export var ValidationErrorType;
(function (ValidationErrorType) {
    ValidationErrorType["Chart"] = "chart";
    ValidationErrorType["Sorting"] = "sorting";
    ValidationErrorType["Filter"] = "filter";
    ValidationErrorType["Metric"] = "metric";
    ValidationErrorType["Model"] = "model";
    ValidationErrorType["Dimension"] = "dimension";
    ValidationErrorType["CustomMetric"] = "custom metric";
})(ValidationErrorType || (ValidationErrorType = {}));
export var ValidationSourceType;
(function (ValidationSourceType) {
    ValidationSourceType["Chart"] = "chart";
    ValidationSourceType["Dashboard"] = "dashboard";
    ValidationSourceType["Table"] = "table";
})(ValidationSourceType || (ValidationSourceType = {}));
export const isTableValidationError = (error) => error.source === ValidationSourceType.Table;
export const isChartValidationError = (error) => error.source === ValidationSourceType.Chart;
export const isDashboardValidationError = (error) => error.source === ValidationSourceType.Dashboard;
export var ValidationTarget;
(function (ValidationTarget) {
    ValidationTarget["CHARTS"] = "charts";
    ValidationTarget["DASHBOARDS"] = "dashboards";
    ValidationTarget["TABLES"] = "tables";
})(ValidationTarget || (ValidationTarget = {}));
export function isValidationTargetValid(validationTarget) {
    return Object.values(ValidationTarget).includes(validationTarget);
}
//# sourceMappingURL=validation.js.map